<script>
  import Sectionheading from './Sectionheading.svelte';
  import SublimationTemplateImage from './SublimationTemplateImage.svelte';

  export let productDetails;

  const productColours = productDetails.Product.Product_Colours;
  const sublimationTemplates = productDetails.Product.Product_SublimationTemplates;
</script>

<Sectionheading subheading="Custom Design Available" heading="Templates" />

<div class="grid">
  {#each sublimationTemplates as template}
    <SublimationTemplateImage
      productRootSlug={productDetails.Product.slug}
      productSlug={productDetails.slug}
      templateDetails={template}
      colourObject={productColours[Math.floor(Math.random() * productColours.length)]}
    />
  {/each}
</div>

<style>
  .grid {
    width: 100%;
    margin: auto;
    padding-top: 4rem;
    padding-bottom: 4rem;
    display: grid;
    grid-template-columns: repeat(2, minmax(200px, 1fr));
    gap: 1rem;
    row-gap: 4rem;
  }

  @media screen and (min-width: 650px) {
    .grid {
      width: 90%;
      grid-template-columns: repeat(3, minmax(200px, 1fr));
    }
  }

  @media screen and (min-width: 900px) {
    .grid {
      width: 90%;
      grid-template-columns: repeat(4, minmax(200px, 1fr));
      row-gap: 6rem;
    }
  }
</style>
